<template>
  <div class="loginView jingyuemls">
    <HeadBar title="个人中心" />
    <div class="loginBox mt50">
      <!-- <img class="logoImgOne" src="https://fmty-picture.oss-cn-hangzhou.aliyuncs.com/123.png" height="85"
        alt="长春疯马体育" />
      <img class="logoImgOne" src="https://fmty-picture.oss-cn-hangzhou.aliyuncs.com/232.png" alt="长春疯马体育"
        height="62" /> -->

      <!-- <img class="logoImgTwo" src="https://fmty-picture.oss-cn-hangzhou.aliyuncs.com/7641701315994_.pic.jpg" height="120"
        alt="长春疯马体育" /> -->
      <img class="logoImgTwo" src="https://fmty-picture.oss-cn-hangzhou.aliyuncs.com/7651701316003_.pic.jpg" height="120"
        alt="长春疯马体育" />

      <van-form @submit="postLogin" class="loginFormOne">
        <van-field v-model="postMobile" name="mobile" label="手机号" placeholder="手机号码" type="tel" ref="mobileInput"
          :rules="[{ required: true }]" />
        <van-field v-model="postCaptcha" type="number" name="captcha" label="验证码" placeholder="验证码"
          :rules="[{ required: false }]">
          <template #button>
            <van-button size="small" type="primary" @click="sendMsg" :disabled="!canClick">{{
              countdownText || "发送验证码"
              }}</van-button>
          </template>
        </van-field>
        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit" class="font-24">登陆</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import { getQueryString, fetchHttp, delAllCookie } from "@/util/fn.js";
  import { Toast, Button, Cell, CellGroup } from "vant";
  const mobileReg = /^1[3456789]\d{9}$/;
  const captchaReg = /^\d{6}$/;
  let second = 0;
  export default {
    name: "loginView",
    components: {
      HeadBar,
      [Button.name]: Button,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
    },
    data() {
      return {
        postMobile: "",
        postCaptcha: "",
        FMTY_USERDATA: "",
        countdownText: "",
        activeNames: ["1"],
        canClick: true
      };
    },
    computed: {

    },
    mounted() {

      let FMTY_USERDATA = Cookies.get("FMTY_USERDATA");
      if (FMTY_USERDATA) {
        this.FMTY_USERDATA = FMTY_USERDATA;
        setTimeout(() => {
          if(window.location.href.includes('/active')){
            window.location.href = '/active/jingyue'
          }else{
            window.location.href = '/index'
          }
        }, 1000);
      } else {
        delAllCookie();        
      }
      let logoRefer = getQueryString('redirect_url')
      console.log(1111,logoRefer);

    },
    methods: {
      //发送验证码
      sendMsg() {
        console.log('发送验证码')
        let mobile = this.postMobile;
        let canClick = this.canClick;
        let self = this;
        if (mobileReg.test(mobile)) {
          if (canClick) {
            fetchHttp("marathon/sendCode", { tel: mobile }, "POST").then(
              (res) => {
                this.canClick = false;
                if (res && res.code === 0) {
                  Toast("验证码已发送，请查收！");
                  self.resetTime();
                }
              }
            );
          }
        } else {
          this.$refs.mobileInput.focus();
          Toast("请填写正确的11位手机号码！");
        }
      },

      //重发验证码
      resetTime() {
        second = 60;
        this.canClick = false;
        let timer = null;
        timer = setInterval(() => {
          second -= 1;
          if (second > 0) {
            this.countdownText = second + "秒后重发";
            this.canClick = false;
          } else {
            second = 0;
            clearInterval(timer);
            this.countdownText = "";
            this.canClick = true;
          }
        }, 1000);
      },

      //登录
      postLogin() {
        let { postMobile, postCaptcha } = this;
        if (captchaReg.test(postCaptcha)) {
          if (postMobile && postCaptcha) {
            fetchHttp(
              "marathon/login",
              {
                tel: postMobile,
                code: postCaptcha,
              },
              "POST"
            ).then((res) => {
              if (res && res.code === 0) {
                Toast("登录成功！");
                //设置token
                Cookies.set("FMTY_TOKEN", res.token, { domain: "ccfmty.com", expires: 30 });
                Cookies.set("USERID", (res.data && res.data.id) || "", { domain: "ccfmty.com", expires: 30 });
                Cookies.set("FMTY_USERDATA", (res.data && res.data.userName) || "", { domain: "ccfmty.com", expires: 30 });

                //判断是否有来源refer
                setTimeout(() => {
                  if (getQueryString("redirect_url")) {
                    window.location.href = getQueryString("redirect_url");
                  } else {
                    window.location.href = "user";
                  }
                }, 1500);
              } else {
                Toast(res.message);
              }
            });
          } else {
            Toast("请填写正确的手机号和验证码！");
          }
        }
      },
    },
  };
</script>
<style scope lang="less">
  .jingyuemls{
    .font-24{
      background-color: #E95513;
      border-color: #E95513;
    }
    .van-button--primary{
      background-color: #E95513;
      border-color: #E95513;
    }
  }
  .logoImgOne {
    margin: 20px auto;
    display: block;
  }
  .logoImgTwo {
    margin: 40px auto 10px;
  }

  .mt50 {
    padding-top: 30px;
  }

  .loginFormOne {
    margin-top: 40px;
  }
</style>